// Notification and Auth0 configuration.
// Values come from environment variables; do not hardcode secrets in source.

const auth0Domain = process.env.REACT_APP_AUTH0_DOMAIN?.replace(/\/$/, '') || null;
const defaultTokenUrl = auth0Domain ? `https://${auth0Domain}/oauth/token` : null;

export const notificationConfig = {
  auth0Domain,
  // SMS token (machine-to-machine) can use a different Auth0 client than the SPA login
  auth0ClientId: process.env.REACT_APP_AUTH0_SMS_CLIENT_ID || process.env.REACT_APP_AUTH0_CLIENT_ID,
  auth0ClientSecret: process.env.REACT_APP_AUTH0_SMS_CLIENT_SECRET || process.env.REACT_APP_AUTH0_CLIENT_SECRET,
  auth0Audience: process.env.REACT_APP_AUTH0_SMS_AUDIENCE || process.env.REACT_APP_AUTH0_AUDIENCE,
  tokenUrl: process.env.REACT_APP_AUTH0_SMS_TOKEN_URL || defaultTokenUrl,
  smsApiBase:
    process.env.REACT_APP_NOTIFICATION_BASE_URL ||
    process.env.REACT_APP_NOTIFICATION_API_BASE ||
    'https://annadaneshwar-notification-service.azurewebsites.net',

  // Call token placeholders (curl to be provided later)
  callTokenUrl: process.env.REACT_APP_AUTH0_CALL_TOKEN_URL || defaultTokenUrl,
  callAuth0ClientId: process.env.REACT_APP_AUTH0_CALL_CLIENT_ID,
  callAuth0ClientSecret: process.env.REACT_APP_AUTH0_CALL_CLIENT_SECRET,
  callAuth0Audience: process.env.REACT_APP_AUTH0_CALL_AUDIENCE,
  callApiBase: process.env.REACT_APP_CALL_API_BASE || 'https://annadaneshwar-cms.azurewebsites.net',
};

export default notificationConfig;
